import React from "react";

import CalloutPanel from "../calloutPanel/calloutPanel.component";
import StatsPanel from "../statsPanel/statsPanel.component";

import { StyledPalette } from "./statsPalette.style";

const StatsPalette = ({ data }) => {
  const callouts = [
    {
      name: "challenges",
      value: !isNaN(data.contestsCount)
        ? Intl.NumberFormat("en-US").format(data.contestsCount)
        : "\u00A0",
    },
    {
      name: "solutions",
      value: !isNaN(data.solutionsCount)
        ? Intl.NumberFormat("en-US").format(data.solutionsCount)
        : "\u00A0",
    },
    {
      name: "cashouts",
      value: !isNaN(data.cashedOut)
        ? Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 0,
          }).format(data.cashedOut)
        : "\u00A0",
    },
  ];

  return (
    <StyledPalette>
      <div className="callout-wrapper">
        {callouts.map((item, index) => (
          <CalloutPanel key={index} data={item} />
        ))}
      </div>
      <StatsPanel data={data} />
    </StyledPalette>
  );
};

export default StatsPalette;
